import './public-path';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import queryDomMethods from './utils/queryDomMethods';
import fontStyleManager from './utils/fontUtils';

declare global {
    interface Window {
        __POWERED_BY_QIANKUN__?: boolean;
        qiankunOptions?: {
            baseUrl?: string;
        };
    }
}
let root: ReactDOM.Root;

const render = (props: any = {}) => {
    if (props) {
        window.qiankunOptions = {
            baseUrl: props.baseUrl,
        };
    }
    if (props.container) {
        fontStyleManager.insertCustomFontStyle(props.container);
        queryDomMethods.setShadowRoot(props.container);
    }

    const container = props?.container?.querySelector('#sub-tiku') || document.getElementById('sub-tiku');
    root = ReactDOM.createRoot(container);
    root.render(<App {...props} />);
};

export async function bootstrap() {}

export async function mount(props: any) {
    render(props);
}

export async function unmount(props: any) {
    fontStyleManager.removeCustomFontStyle();
    root && root.unmount();
}

export async function update(props: any) {
    console.log('🚀 ~ update ~ props:', props);
}

if (!window.__POWERED_BY_QIANKUN__) {
    render();
}
